var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupMinusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9997 25.6668C8.50001 25.6668 5.75017 25.6668 4.04101 23.9577C2.33301 22.2508 2.33301 19.4998 2.33301 14.0002C2.33301 8.5005 2.33301 5.75066 4.04101 4.0415C5.75134 2.3335 8.50001 2.3335 13.9997 2.3335C19.4993 2.3335 22.2492 2.3335 23.9572 4.0415C25.6663 5.75183 25.6663 8.5005 25.6663 14.0002C25.6663 19.4998 25.6663 22.2497 23.9572 23.9577C22.2503 25.6668 19.4993 25.6668 13.9997 25.6668ZM18.3747 14.0002C18.3747 14.2322 18.2825 14.4548 18.1184 14.6189C17.9543 14.783 17.7317 14.8752 17.4997 14.8752H10.4997C10.2676 14.8752 10.0451 14.783 9.88096 14.6189C9.71686 14.4548 9.62467 14.2322 9.62467 14.0002C9.62467 13.7681 9.71686 13.5455 9.88096 13.3814C10.0451 13.2174 10.2676 13.1252 10.4997 13.1252H17.4997C17.7317 13.1252 17.9543 13.2174 18.1184 13.3814C18.2825 13.5455 18.3747 13.7681 18.3747 14.0002Z",
    fill: "#FD7401"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupMinusIcon);
export default __webpack_public_path__ + "static/media/group-minus-icon.91ec0165965b939bd6897f530bb09dfe.svg";
export { ForwardRef as ReactComponent };